import ReactEcharts from "echarts-for-react";

export function ComplexPieChart({ style, dados = [], paletaDeCores = [] }) {
  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}<br/> <strong>{c}%</strong>",
    },
    legend: {
      orient: "vertical",
      left: "right",
      textStyle: {
        fontWeight: "bold",
      },

      selectedMode: false,
    },
    series: [
      {
        name: "Dataset",
        type: "pie",
        radius: "50%",
        data: dados,
        color: paletaDeCores,
        label: {
          formatter: "{d}%",
          position: "inside",
          fontSize: 18,
          fontWeight: "bold",
          color: "white",
          textBorderColor: "#777",
          textBorderWidth: 2,
        },
        labelLine: {
          show: false,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  return <ReactEcharts option={option} style={style} />;
}
